import { Carousel } from "@ttc3k/trekker";
import { Maybe, AssetImage } from "gql/generated";
import { Box } from "styled-system/jsx";
import { css } from "styled-system/css";
import { CloudinaryImage } from "shared/components";
import { limitFill } from "@cloudinary/transformation-builder-sdk/actions/resize";
import { autoGravity } from "@cloudinary/transformation-builder-sdk/qualifiers/gravity";

type HeroImageProps = {
  images: AssetImage[] | Maybe<AssetImage>[] | undefined;
};

export const HeroImage = ({ images }: HeroImageProps) => {
  if (!images || images.length < 1) {
    return null;
  }

  const hasMultipleImages = images.length > 1;

  return (
    <>
      <Box
        mb="-20px"
        position={hasMultipleImages ? "sticky" : undefined}
        top={hasMultipleImages ? 0 : undefined}
      >
        <Carousel
          images={images}
          height={484}
          tagClassName={css({ pb: "150" })}
          controlClassName={css({ pb: "150" })}
          render={(image: Partial<AssetImage>) => (
            <CloudinaryImage
              image={image}
              imageStyleProps={{
                className: css({ h: "484px" }),
                width: "full",
                aspectRatio: "unset",
              }}
              resize={limitFill().height(484).gravity(autoGravity())}
            />
          )}
        />
      </Box>
    </>
  );
};
